import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import applicationSettings from '../../Core/Settings/ApplicationSettings';
import PageLoadingSpinner from '../../Refactor/Components/LoadingSpinner/PageLoadingSpinner';
import NavigationRoutes from '../NavigationRoutes';

const Logout = () => {
    const { oktaAuth } = useOktaAuth();
    const navigate = useNavigate();

    const handleLogout = () => oktaAuth.signOut({ postLogoutRedirectUri: applicationSettings.okta.postLogoutRedirectUri });

    useEffect(() => {
        handleLogout();
        navigate(NavigationRoutes.Home);
    }, []);

    return <PageLoadingSpinner />;
};

export default Logout;
